const AuthenticationStatusService = function ($http, $location, $q, $window) {
    const url = __baseApiUrl__ + "/participant-web-services/rest/nonauth/isAuthenticated";
    const clearCookieUrl =
        __baseApiUrl__ + "/participant-web-services/rest/nonauth/clearLanguageCookies";

    let cache = undefined;
    let getAuthStatusRequestOut = false;
    let deferred = $q.defer();

    this.getAuthData = function (clearCache) {
        if (clearCache) {
            this.clearCache();
        }

        if (!getAuthStatusRequestOut && cache === undefined) {
            getAuthStatusRequestOut = true;
            $http({
                url: url,
                method: "POST",
                data: {},
                isArray: false
            }).then(
                function (resp) {
                    getAuthStatusRequestOut = false;
                    cache = resp.data;
                    deferred.resolve(cache);
                },
                function (error) {
                    console.error("AuthenticationStatusService.getAuthData(): ", error);
                    deferred.error(error);
                }
            );
        }

        return deferred.promise;
    };

    this.clearSpanishLanguageCookies = function () {
        if ($location.$$host === "localhost") {
            return new Promise((resolve) => {
                resolve({ Status: "successful" });
            });
        }
        const https = "https://";
        const http = "http://";
        const period = ".";
        let newBaseApiUrl = __baseApiUrl__;
        const toLangCode = "es";
        if (
            __baseApiUrl__.indexOf(https + toLangCode) < 0 &&
            __baseApiUrl__.indexOf(http + toLangCode) < 0
        ) {
            newBaseApiUrl = newBaseApiUrl.replace(https, https + toLangCode + period);
            newBaseApiUrl = newBaseApiUrl.replace(http, http + toLangCode + period);
        }
        if (
            newBaseApiUrl.indexOf(https + toLangCode) < 0 &&
            newBaseApiUrl.indexOf(http + toLangCode) < 0
        ) {
            if (!$window.location.origin) {
                $window.location.origin =
                    $window.location.protocol +
                    "//" +
                    $window.location.hostname +
                    ($window.location.port ? ":" + $window.location.port : "");
            }
            newBaseApiUrl = $window.location.origin;
            if (
                newBaseApiUrl.indexOf(https + toLangCode) < 0 &&
                newBaseApiUrl.indexOf(http + toLangCode) < 0
            ) {
                newBaseApiUrl = newBaseApiUrl.replace(https, https + toLangCode + period);
                newBaseApiUrl = newBaseApiUrl.replace(http, http + toLangCode + period);
            }
        }
        const clearSpanishCookieUrl =
            newBaseApiUrl + "/participant-web-services/rest/nonauth/clearSpanishLanguageCookies";
        return $http({
            url: clearSpanishCookieUrl,
            method: "GET",
            isArray: false
        });
    };

    this.clearEnglishLanguageCookies = function () {
        const newBaseApiUrl = this.getEnglishBaseApiUrl();
        const clearEnglishCookieUrl =
            newBaseApiUrl + "/participant-web-services/rest/nonauth/clearEnglishLanguageCookies";
        return $http({
            url: clearEnglishCookieUrl,
            method: "GET",
            isArray: false
        });
    };

    this.clearLanguageCookiesFromEngSite = function () {
        const newBaseApiUrl = this.getEnglishBaseApiUrl();
        const clearLanguageCookieUrl = newBaseApiUrl + clearCookieUrl;
        return $http({
            url: clearLanguageCookieUrl,
            method: "GET",
            isArray: false
        });
    };

    this.setAccuCodeCookies = function () {
        const newBaseApiUrl = this.getEnglishBaseApiUrl();
        const setAccuCodeCookieUrl =
            newBaseApiUrl + "/participant-web-services/rest/nonauth/setAccuCodeCookies";
        return $http({
            url: setAccuCodeCookieUrl,
            method: "GET",
            isArray: false,
            headers: { "Content-Type": "application/json" }
        });
    };

    this.clearLanguageCookies = function () {
        return $http({
            url: clearCookieUrl,
            method: "GET",
            isArray: false
        });
    };

    this.getEnglishBaseApiUrl = function () {
        const https = "https://";
        const http = "http://";
        const period = ".";
        let newBaseApiUrl = __baseApiUrl__;
        const toLangCode = "es";
        if (
            __baseApiUrl__.indexOf(https + toLangCode) >= 0 ||
            __baseApiUrl__.indexOf(http + toLangCode) >= 0
        ) {
            newBaseApiUrl = newBaseApiUrl.replace(https + toLangCode + period, https);
            newBaseApiUrl = newBaseApiUrl.replace(http + toLangCode + period, http);
        }
        if (
            newBaseApiUrl === "" ||
            newBaseApiUrl.indexOf(https + toLangCode) >= 0 ||
            newBaseApiUrl.indexOf(http + toLangCode) >= 0
        ) {
            if (!$window.location.origin) {
                $window.location.origin =
                    $window.location.protocol +
                    "//" +
                    $window.location.hostname +
                    ($window.location.port ? ":" + $window.location.port : "");
            }
            newBaseApiUrl = $window.location.origin;
            if (
                newBaseApiUrl.indexOf(https + toLangCode) >= 0 ||
                newBaseApiUrl.indexOf(http + toLangCode) >= 0
            ) {
                newBaseApiUrl = newBaseApiUrl.replace(https + toLangCode + period, https);
                newBaseApiUrl = newBaseApiUrl.replace(http + toLangCode + period, http);
            }
        }
        return newBaseApiUrl;
    };

    this.clearCache = function () {
        cache = undefined;
        deferred = $q.defer();
    };

    return {
        getAuthData: this.getAuthData,
        clearCache: this.clearCache,
        clearLanguageCookies: this.clearLanguageCookies,
        clearLanguageCookiesFromEngSite: this.clearLanguageCookiesFromEngSite,
        getEnglishBaseApiUrl: this.getEnglishBaseApiUrl,
        setAccuCodeCookies: this.setAccuCodeCookies,
        clearSpanishLanguageCookies: this.clearSpanishLanguageCookies,
        clearEnglishLanguageCookies: this.clearEnglishLanguageCookies
    };
};

AuthenticationStatusService.$inject = ["$http", "$location", "$q", "$window"];
export default AuthenticationStatusService;
